import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export function isContract(objectTypeId) {
  return objectTypeId === CONTRACT_TYPE_ID;
}
export function isActionUnavailable({
  objectId,
  objectTypeId,
  skip
}) {
  return Boolean(skip || !isContract(objectTypeId) || !objectId || objectId === -1);
}